import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="w-full bg-[#FFF8F0] py-10 md:py-14 px-4" data-id="element-85">
      <div className="max-w-3xl mx-auto text-center" data-id="element-86">
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-sm md:text-base font-semibold tracking-widest text-[#5B8A7A] uppercase mb-3" data-id="element-87">
          For Parents of Picky Eaters
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="font-['Playfair_Display'] text-3xl md:text-5xl lg:text-6xl font-bold text-[#2D4A3E] leading-tight mb-4" data-id="element-88">
          The "Peace At Dinner" Protocol: End the Mealtime Standoff Without
          Cooking Two Separate Meals
        </motion.h1>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="font-['Source_Sans_3'] text-lg md:text-xl lg:text-2xl text-[#3A3A3A] font-normal leading-relaxed mb-7 max-w-2xl mx-auto" data-id="element-89">
          The 7-Day "Exposure Ladder" System to Turn 6 PM Screaming Into Calm
          Exploration (Even for the Most Stubborn Picky Eaters)
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mb-7" data-id="element-90">
          <img src="https://cdn.magicpatterns.com/uploads/48uN9sFeRM1zXrt5zeNTND/Peace_At_Dinner.png" alt="Parents happily reviewing the Peace At Dinner protocol on a tablet while enjoying a meal with their child" className="w-full max-w-2xl mx-auto rounded-2xl shadow-xl" data-id="element-91" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-92">
          <a href="#get-protocol" className="inline-block bg-[#C4883A] hover:bg-[#A8712E] text-white font-semibold text-lg md:text-xl px-10 py-4 rounded-lg shadow-lg transition-all duration-300 hover:shadow-xl hover:scale-105" data-id="element-93">
            GET THE PROTOCOL — $6.36
          </a>
          <p className="mt-4 text-sm text-[#5B8A7A] font-medium" data-id="element-94">
            Instant PDF Access • No Physical Shipping Required
          </p>
        </motion.div>
      </div>
    </section>;
}